import { render } from "./NewBlacklist.vue?vue&type=template&id=29a0c40d"
import script from "./NewBlacklist.vue?vue&type=script&lang=js"
export * from "./NewBlacklist.vue?vue&type=script&lang=js"

import "./NewBlacklist.vue?vue&type=style&index=0&id=29a0c40d&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__